module.exports = __webpack_public_path__ + "img/notice.5d552cc9.png";